<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Daily Log Book</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id"
                        :items="academic_year_list" item-text="academicyear" label="Select Academic Year" outlined
                        @click="show = false" persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="user_type == 'Parent'">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children"
                        label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                        @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field rounded outlined dense v-model="new_from_date" id="datePickerId" type="date"
                       :rules="[(v) => !!v || 'required']" persistent-hint
                        label="Select Date"></v-text-field>

                </v-col>

            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="3" md="1">

                </v-col>
                <v-col cols="12" sm="3" md="1">

                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" :loading="fetch_loader" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12" v-if="daily_log_book_list != ''">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Daily Log Book List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-btn rounded color="success" outlined class="ma-4"
                        @click="fnExcelReport('my-table-id', 'Parent Daily Log Book')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                    <div id="my-table-id">
                        <v-data-table dense :headers="displayedHeaders" :items="daily_log_book_list" sort-by
                            class="elevation-1 mytable" :search="search">
                        </v-data-table>
                    </div>



                </v-col>
            </v-row>

            <!-- {{crs_plan_execution_list}} -->

        </v-card>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Student Log Book Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/jp9PLcgFT68?si=DiRpz3oI16h-eNQj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data() {
        return {
            org_id:null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            videoDialog:false,
            loader: true,
            children: [],
            academic_year_list: [],
            selected_children: null,
            selected_ay: null,
            fetch_loader: false,
            daily_log_book_list: [],
            crs_plan_execution_list: [],
            new_from_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            xls_header: {
                Period: "Period",
                Subject: "Subject",
                Content: "Content",
                Homework: "homework",
                Remark: "remark",
            },
            headers: [
                // { text: "Period", value: "Period" },
                { text: "Subject", value: "Subject" },
                { text: "Content", value: "Content" },

                { text: "Homework", value: "homework" },
                { text: "Remark", value: "remark" },
            ],
            user_type: null,
            dialog: false,
            uid: null,
            search:"",
        };
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        getDetails() {

            var registration_number;
            if (this.user_type == "Parent") {
                registration_number = this.selected_children.registration_number;
            }
            if (this.user_type == "Student") {
                //  alert(this.uid)
                registration_number = this.uid;
            }
            const data = {
                user_type: this.user_type,
                registration_no: registration_number,
                ay: this.selected_ay,
                new_from_date: this.new_from_date,
            };
            this.fetch_loader = true;
            this.daily_log_book_list=[]
            axios
                .post("/parent/getdailylogbook", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.daily_log_book_list = res.data.daily_log_book_list;
                        this.fetch_loader = false;
                        if(this.daily_log_book_list.length <= 0){
                            this.showSnackbar("#b71c1c", "No Records Found..");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.fetch_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.fetch_loader = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                });
        },
    },
    watch: {


    },
    computed: {
    displayedHeaders() {
        // Add "Period" header conditionally
        return this.org_id == 'sanjivani'
            ? [{ text: "Period No", value: "period_no" }, ...this.headers]
            : this.headers;
    }
},
    mounted() {
        this.org_id = localStorage.getItem("EPS-tenant");
        this.user_type = localStorage.getItem("EPS-ut");
        if (this.user_type == "Student") {
            this.uid = localStorage.getItem("EPS-uid");
        }
        //alert(this.user_type)
        let org_id = localStorage.getItem("EPS-tenant");
        axios
            .post("/AccountingAndFees/getChildList")
            .then((res) => {
                if (res.data.msg == "200") {
                    if ((res.data.status = "SUCCESS")) {
                        this.children = res.data.learners;
                        this.academic_year_list = res.data.academic_year_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    }
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something Went Wrong");
            })
            .finally(() => {
                //close loader
                this.loader = false;
                //alert("done")
            });
    },
};
</script>
<style>
tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    text-align: center;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
        text-align: center;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
        text-align: center;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}
</style>
